import { KYMW0A00Model } from '../kymw0a00.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * ＮＧワードチェックするサービス
 *
 * @export CheckNgWords0AService
 * @class CheckNgWords0AService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class CheckNgWords0AService extends PlessJsonResponderSub<any> {
  private model: KYMW0A00Model = null;
  private checkStr: string;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof CheckNgWords0AService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        String: this.checkStr
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model KYMW0A00Model
   * @memberof CheckNgWords0AService
   */
  execute(model: KYMW0A00Model, checkStr: string, successFunc: Function): void {
    this.model = model;
    this.checkStr = checkStr;
    this.successFunc = successFunc;
    this.send('checkNgWords0A', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof CheckNgWords0AService
   */
  success(data: any): void {
    // サーバからの結果を元に、ＮＧワードを更新する
    this.model.checkNgWords(data);
    // 後続処理を実行
    this.successFunc();
  }
}
